import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import Cookies from "js-cookie";

const state = () => ({
  meta: {
    totalCount: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false
  },
  link: null,
  collection: [],
  userMeta: {
    page: 1,
    hasNextPage: true,
    size: 40
  },
  dateRange: {
    start: "",
    end: ""
  },
  users: [],
  groups: [],
  products: [],
  userActive: 0,
  userTab: 0,
  activeUser: null,
  historyPickedUser: null,
  settingsLoader: false,
  locations: [],
  locationMeta: {
    page: 1,
    hasNextPage: true
  },
  categories: [],
  categoryMeta: {
    page: 1,
    hasNextPage: true
  },
  events: [],
  eventMeta: {
    page: 1,
    hasNextPage: true,
    size: 40
  },
  schedules: [],
  newSchedules: getDataFromStorage("newSchedules"),
  scheduleMeta: {
    page: 1,
    hasNextPage: true
  },
  setPayMethod: {},
  totalBookingsToday: 0
});

export default {
  state,
  actions,
  getters,
  mutations
};

function getDataFromStorage(key, type = "cookie") {
  if (type === "cookie") {
    return Cookies.getJSON(key) || [];
  }

  return;
}
